module.exports = __webpack_public_path__ + "static/defaultmail-88ab243ba6303951edb09c5afb9c538b.svg";